var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import styled from '../styled-components';
import logo from '../../logo.png';
export var LogoImg = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: auto;\n  max-width: 100%;\n  height: auto;\n  display: block;\n"], ["\n  width: auto;\n  max-width: 100%;\n  height: auto;\n  display: block;\n"])));
var LogoContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 180px;\n"], ["\n  width: 180px;\n"])));
var Logo = function () { return (React.createElement(LogoContainer, null,
    React.createElement(LogoImg, { src: logo }))); };
export default Logo;
var templateObject_1, templateObject_2;
